// extracted by mini-css-extract-plugin
module.exports = {"button":"_19327f7","desktop":"_8ddd32b","single":"_f072f6f","sm":"_b0cac1e","multi":"_03670e5"};